// Canvas.js
import React from 'react'
import { useEffect, useContext, useRef } from 'react'
import { observer } from 'mobx-react-lite'
import styles from './Canvas.module.css'
import HeaderCanvas from './components/Header/HeaderCanvas'
import EditorCanvas from './components/Editor/EditorCanvas'
import headersForms from '../../../../components/HeadersForms/headersForms'

import { BuilderContext } from '../store/store.Builder'

const Canvas = observer(() => {
  const renderCountRef = useRef(0)
  renderCountRef.current += 1

  const canvasRef = useRef(null)

  const handleCanvasClick = (event) => {
    if (event.target === canvasRef.current) {
      console.log('Clic hors du canvas')
      builderContext.setSelectedField(null)
    }
  }

  useEffect(() => {
    console.log(`Canvas render count: ${renderCountRef.current}`)
  })
  const builderContext = useContext(BuilderContext)

  useEffect(() => {
    console.log(builderContext.canvasSize)
  }, [builderContext.canvasSize])

  return (
    <div
      ref={canvasRef}
      onClick={handleCanvasClick}
      className={`${styles.canvas} ${
        styles[builderContext.getCanvasSizeClassName()]
      }`}
    >
      <div
        className={`${styles.canvas__container} ${
          styles[builderContext.canvasSize]
        }`}
      >
        <EditorCanvas />
      </div>
    </div>
  )
})

export default Canvas
